import Footer from '../components/Footer';
import { usePageView } from '../hooks/usePageView';
import { useScrollTracking } from '../hooks/useScrollTracking';
import { pushToDataLayer } from '../utils/gtm';

export default function ArtikelBodyBoost() {
  usePageView('page_view_bodyboost');
  useScrollTracking({ event50: 'scroll_50_bodyboost', event90: 'scroll_90_bodyboost' });

  return (
    <div className="min-h-screen bg-white">
      <article className="max-w-4xl mx-auto px-6 py-8">
        <header className="mb-12 border-b pb-8">
          <div className="mb-8">
            <img src="/vegitech logo web.png" alt="Vegitech Logo" className="h-12" />
          </div>

          <div className="flex items-center gap-3 mb-6">
            <div className="flex items-center">
              <span className="text-[#fbbf24] text-2xl">★</span>
              <span className="text-[#fbbf24] text-2xl">★</span>
              <span className="text-[#fbbf24] text-2xl">★</span>
              <span className="text-[#fbbf24] text-2xl">★</span>
              <span className="relative inline-block text-2xl">
                <span className="text-gray-300">★</span>
                <span className="absolute top-0 left-0 text-[#fbbf24] overflow-hidden inline-block w-1/2">★</span>
              </span>
            </div>
            <span className="text-lg text-gray-700">4,5 von 5 Sternen</span>
          </div>

          <p className="text-gray-500 mb-8">
            Zuletzt aktualisiert am Montag, 22. September 2025 <span className="ml-4 text-gray-600">Advertorial</span>
          </p>

          <h2 className="text-4xl md:text-5xl font-bold text-black leading-tight mb-6">
            Die 7-Tage-Methode, die tausende Deutsche überrascht – und warum sie nichts mit Diät zu tun hat
          </h2>
          <p className="text-lg text-gray-700 italic">
            „Ein Erfahrungsbericht zeigt, wie diese Methode Menschen hilft, ihre Gesundheit zu verbessern."
          </p>
        </header>

        <div className="mb-8">
          <img src="/ulrikvevorhernacher.png" alt="Transformation vorher nachher" className="w-full rounded-lg shadow-lg" />
        </div>

        <div className="space-y-6 text-base text-black leading-relaxed">
          <h2 className="text-3xl font-bold text-black mt-8 mb-4">
            „Ich wusste nicht mehr, wo ich anfangen sollte."
          </h2>

          <p>
            Als Claudia (52) an einem Sonntagmorgen in den Spiegel blickt, hat sie keine Lust mehr auf das ewige Auf und Ab. „Ich war müde, gereizt, gestresst. Morgens keine Energie, abends Heißhunger. Ich hatte das Gefühl, mein Körper läuft gegen mich."
          </p>

          <p>
            Sie hatte <em>alles</em> versucht – Low Carb, Intervallfasten, Smoothie-Kuren. Doch jedes Mal dasselbe Spiel: motiviert starten, nach drei Tagen abbrechen.
          </p>

          <p>
            „Es war wie ein Dschungel. Überall Tipps, Rezepte, Regeln. Ich wusste gar nicht mehr, wem ich glauben sollte."
          </p>

          <p>
            Dann stößt sie zufällig auf ein Programm mit dem Satz:
          </p>

          <p className="text-lg font-bold text-center my-6 p-4 bg-yellow-50 border-l-4 border-yellow-500">
            „In 7 Tagen spürbar leichter, klarer und energiegeladener – mit nur 30 Minuten pro Tag."
          </p>

          <p>
            Neugierig klickt sie.
          </p>

          <h2 className="text-3xl font-bold text-black mt-12 mb-4">
            Ein klarer Plan statt 1.000 Regeln
          </h2>

          <p>
            Claudia meldet sich zum <strong>7-Tage-Body-Boost</strong> an – einem Onlinekurs, der Bewegung, Ernährung, Schlaf, Stress und Mindset zu einem klaren Fahrplan verbindet.
          </p>

          <p>
            „Das Erste, was mich überzeugt hat, war die Struktur. Es gibt keinen Raum für Grübeln. Ich bekomme jeden Tag gesagt, was zu tun ist. Und das fühlt sich gut an."
          </p>

          <p>
            7 Tage – 7 Module.
          </p>

          <p>
            Jeden Tag 30 Minuten Coaching, Workouts und einfache Rezepte.
          </p>

          <p>
            Dazu Einkaufslisten, Bonus-Audios und kleine mentale Übungen.
          </p>

          <p>
            Claudia lacht: „Ich musste nur folgen – und plötzlich war alles leicht."
          </p>

          <h2 className="text-3xl font-bold text-black mt-12 mb-4">
            Warum das Programm so anders ist
          </h2>

          <div className="md:float-right md:ml-6 md:mb-4 md:w-80 w-full my-6">
            <div className="relative">
              <img
                src="/siggi.jpeg"
                alt="Siggi Spaleck"
                className="w-full rounded-lg shadow-lg"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-75 text-white p-3 rounded-b-lg">
                <p className="text-sm font-semibold">Siggi Spaleck, Experte für Neuroplastizität & Coach (&gt;20.000 Sessions)</p>
              </div>
            </div>
          </div>

          <p>
            Der Entwickler, <strong>Siggi Spaleck</strong>, ist seit über 20 Jahren Fitness- und Mindset-Coach.
          </p>

          <p>
            Sein Prinzip: Veränderung funktioniert nicht durch Zwang, sondern durch <strong>Neuroplastizität</strong> – also das Neuprogrammieren des Autopiloten im Kopf.
          </p>

          <p className="text-lg italic pl-4 border-l-4 border-gray-300">
            „Viele Menschen scheitern nicht an Motivation, sondern an Überforderung", erklärt Spaleck.
          </p>

          <p>
            „Wenn du jeden Tag weißt, was zu tun ist, entsteht automatisch Momentum. Der Körper zieht nach."
          </p>

          <p>
            Der Kurs kombiniert:
          </p>

          <ul className="list-disc pl-6 space-y-2">
            <li><strong>30-Minuten-Workouts</strong> (auch für Einsteiger & 50+)</li>
            <li><strong>Ernährungspläne & Einkaufslisten</strong> (normal, vegetarisch, vegan)</li>
            <li><strong>Stress- und Schlafroutinen</strong></li>
            <li><strong>Mindset-Training</strong>, um alte Muster zu durchbrechen</li>
          </ul>

          <div className="my-8">
            <img src="/hack dein gerhin.jpeg" alt="Neuroplastizität - Hack dein Gehirn" className="w-full rounded-lg shadow-lg" />
          </div>

          <h2 className="text-3xl font-bold text-black mt-12 mb-4">
            Die ersten Tage – spürbare Veränderung
          </h2>

          <p>
            Am dritten Tag bemerkt Claudia, dass sie morgens leichter aus dem Bett kommt. „Ich war überrascht, wie viel Energie ich hatte. Ich brauchte keinen Kaffee mehr, um wach zu werden."
          </p>

          <p>
            <strong>Tag 4:</strong> Kein Heißhunger mehr.
          </p>

          <p>
            <strong>Tag 5:</strong> Die Jeans sitzt lockerer.
          </p>

          <p>
            <strong>Tag 7:</strong> 2,2 Kilo weniger – aber das sei gar nicht das Wichtigste, sagt sie.
          </p>

          <p className="text-lg font-semibold">
            „Ich fühlte mich, als hätte jemand den Reset-Knopf gedrückt."
          </p>

          <h2 className="text-3xl font-bold text-black mt-12 mb-4">
            Belohnung statt Garantie
          </h2>

          <p>
            Ein Detail, das sie besonders motiviert hat: die <strong>„5-Kilo-Challenge Money-Back"</strong>.
          </p>

          <p>
            Wer innerhalb der 7 Tage <strong>5 kg oder mehr verliert</strong>, kann den vollen Kaufpreis zurückbekommen – als <strong>Belohnung für Erfolg</strong>, nicht als Rücktrittsrecht.
          </p>

          <p>
            „Das fand ich genial. Kein Druck, sondern Anreiz. Ich wusste: Ich kann nur gewinnen."
          </p>

          <h2 className="text-3xl font-bold text-black mt-12 mb-4">
            Der Unterschied: Kein Druck, kein Verzicht – sondern Klarheit
          </h2>

          <p>
            Claudia hatte früher immer gedacht: „Wenn ich abnehmen will, muss ich leiden."
          </p>

          <p>
            Heute sieht sie das anders:
          </p>

          <p className="text-lg italic pl-4 border-l-4 border-gray-300">
            „Hier geht's nicht um Kalorienzählen oder Hungern, sondern um Struktur. Ich musste nicht überlegen, was ich darf oder nicht darf. Ich hatte einfach einen Plan – und das war Gold wert."
          </p>

          <h2 className="text-3xl font-bold text-black mt-12 mb-4">
            Was sie nach 7 Tagen mitnimmt
          </h2>

          <p>
            Nach einer Woche hat Claudia:
          </p>

          <ul className="list-disc pl-6 space-y-2">
            <li>2,2 kg verloren</li>
            <li>So gut geschlafen wie lange nicht mehr</li>
            <li>keine Heißhungerattacken mehr</li>
            <li>wieder Lust auf Bewegung</li>
          </ul>

          <p className="text-lg font-semibold">
            „Ich fühle mich endlich wieder lebendig – und das nach nur einer Woche."
          </p>

          <p>
            Und das Beste: Der Plan geht weiter. Denn die Routinen lassen sich leicht in den Alltag übernehmen.
          </p>

          <h2 className="text-3xl font-bold text-black mt-12 mb-4">
            Warum das Programm besonders für 35–60 funktioniert
          </h2>

          <p>
            Die meisten Diäten ignorieren, dass Stress, Schlafmangel und Hormone mitspielen.
          </p>

          <p>
            Der 7-Tage-Body-Boost dagegen <strong>verbindet Körper und Kopf</strong>:
          </p>

          <p>
            Erst wenn der Alltag wieder planbar ist, kann der Körper loslassen.
          </p>

          <p>
            Viele Teilnehmer berichten genau das:
          </p>

          <div className="bg-gray-50 p-4 my-6 space-y-3 italic">
            <p>„Endlich wieder Energie morgens!"</p>
            <p>„Ich hab wieder Lust auf gesunde Mahlzeiten!"</p>
            <p>„Es tut gut, dass jemand mitdenkt!"</p>
          </div>

          <h2 className="text-3xl font-bold text-black mt-12 mb-4">
            Wissenschaftlich fundiert – alltagstauglich umgesetzt
          </h2>

          <p>
            Das Programm basiert auf der <strong>Autopilotmethode</strong> von Siggi Spaleck – einer Verbindung aus Neuroplastizität, Stressmanagement, Ernährung und Bewegung.
          </p>

          <p>
            Es nutzt denselben Mechanismus, mit dem man schlechte Gewohnheiten ablegt: Wiederholung + Struktur = Erfolg.
          </p>

          <h2 className="text-3xl font-bold text-black mt-12 mb-4">
            Was du bekommst
          </h2>

          <ul className="list-disc pl-6 space-y-2">
            <li>7-Tage-Kurs mit Videos, Ernährungsplänen & Einkaufslisten</li>
            <li>7 kurze Workouts à 30 Minuten</li>
            <li>Schlaf- & Stressmanagement</li>
            <li>Mindset-Training (Autopilot-Prinzip)</li>
            <li>Bonus-Audios, Rezepte, Notizvorlagen</li>
            <li>Zugang über Digistore, sofort nach Kauf</li>
          </ul>

          <p className="text-xl font-bold my-6">
            Preis: ab 49 € (Einmalzahlung)
          </p>

          <h2 className="text-3xl font-bold text-black mt-12 mb-4">
            Fazit: Keine Wunder, sondern ein klarer Weg
          </h2>

          <p>
            Claudia fasst es so zusammen:
          </p>

          <p className="text-lg italic pl-4 border-l-4 border-gray-300 mb-6">
            „Ich wollte wieder in meinen Körper vertrauen – und das Programm hat mir gezeigt, wie. Es ist kein Hokuspokus, sondern Struktur, die funktioniert."
          </p>

          <p>
            Der <strong>7-Tage-Body-Boost</strong> ist kein weiterer Diät-Trick, sondern ein Reset, der Ordnung, Energie und Leichtigkeit zurückbringt.
          </p>

          <p>
            Wer starten will, bekommt alles Nötige in einem Kurs – und die Belohnung, wenn's richtig läuft.
          </p>

          <div className="my-8">
            <img src="/ProductBundle.jpeg" alt="7-Tage-Body-Boost Programm" className="w-full rounded-lg shadow-lg" />
            <div className="bg-gradient-to-br from-emerald-600 via-teal-600 to-cyan-600 p-8 rounded-b-lg -mt-1 shadow-2xl">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 mb-6">
                <div className="flex items-center justify-center gap-4 mb-4">
                  <span className="text-white/80 text-2xl line-through">149€</span>
                  <span className="text-white text-4xl font-bold">49€</span>
                  <span className="bg-yellow-400 text-black text-sm font-bold px-3 py-1 rounded-full">67% RABATT</span>
                </div>
                <p className="text-white/90 text-center text-sm">Einführungspreis nur für die ersten 100 Teilnehmer</p>
              </div>

              <div className="space-y-3 mb-6">
                <div className="flex items-center gap-3 text-white">
                  <svg className="w-5 h-5 text-yellow-400 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-sm">Sofortiger Zugang zum kompletten Programm</span>
                </div>
                <div className="flex items-center gap-3 text-white">
                  <svg className="w-5 h-5 text-yellow-400 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-sm">Alle Ernährungspläne & Neuroplastizitäts-Übungen</span>
                </div>
                <div className="flex items-center gap-3 text-white">
                  <svg className="w-5 h-5 text-yellow-400 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-sm">30 Tage Geld-zurück-Garantie</span>
                </div>
              </div>

              <a
                href="/"
                className="block w-full bg-white text-emerald-700 text-center px-8 py-4 rounded-xl font-bold text-lg hover:bg-yellow-400 hover:text-black transition-all duration-300 shadow-2xl hover:shadow-yellow-400/50 hover:scale-105 transform"
                onClick={() => pushToDataLayer('click_to_offer_from_bodyboost')}
              >
                Jetzt Einführungspreis sichern – nur 49€
              </a>

              <div className="flex items-center justify-center gap-2 mt-4 text-white/80 text-xs">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                </svg>
                <span>Sichere Bezahlung • Sofortiger Zugang</span>
              </div>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-black mt-8 mb-4">
            Für wen ist diese Methode ideal?
          </h2>

          <p>Für Menschen, die:</p>

          <ul className="list-disc pl-6 space-y-2">
            <li>einen schnellen Reset wollen</li>
            <li>sich wieder leichter fühlen wollen</li>
            <li>endlich aus alten Mustern raus wollen</li>
            <li>frustriert sind von klassischen Diäten</li>
            <li>wenig Zeit haben</li>
            <li>mentale Leichtigkeit suchen</li>
          </ul>

          <h2 className="text-2xl font-bold text-black mt-8 mb-4">
            Fazit der Redaktion
          </h2>

          <p>Der 7-Tage-Body-Boost verbindet erstmals:</p>

          <ul className="list-disc pl-6 space-y-2">
            <li>Neuroplastizität</li>
            <li>kurze tägliche Impulse</li>
            <li>realistische Ernährung</li>
            <li>Stress-Reset</li>
            <li>direkte spürbare Ergebnisse</li>
          </ul>

          <p className="mt-4">
            Mit dem begrenzten Einführungsangebot für 100 Plätze ist es eine der aktuell spannendsten Gesundheitsmethoden auf dem Markt.
          </p>

          <div className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 rounded-2xl p-8 text-center my-8 shadow-2xl border border-yellow-400/20 overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-yellow-400/10 rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-teal-400/10 rounded-full blur-3xl"></div>

            <div className="relative z-10">
              <div className="inline-block bg-yellow-400 text-black text-xs font-bold px-4 py-2 rounded-full mb-4 uppercase tracking-wider">
                ⚡ Limitiertes Angebot
              </div>

              <h3 className="text-white text-2xl font-bold mb-2">
                Starte noch heute deinen 7-Tage-Body-Boost
              </h3>

              <p className="text-white/70 text-sm mb-6 max-w-2xl mx-auto">
                Nur noch <span className="text-yellow-400 font-bold">67 von 100</span> Einführungsplätzen verfügbar
              </p>

              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 mb-6 max-w-md mx-auto border border-white/10">
                <div className="flex items-center justify-center gap-4 mb-3">
                  <div className="text-center">
                    <div className="text-white/60 text-sm line-through mb-1">Normalpreis</div>
                    <div className="text-white/80 text-xl font-bold line-through">149€</div>
                  </div>
                  <div className="text-white/40 text-3xl">→</div>
                  <div className="text-center">
                    <div className="text-yellow-400 text-sm mb-1">Dein Preis heute</div>
                    <div className="text-white text-3xl font-bold">49€</div>
                  </div>
                </div>
                <div className="text-emerald-400 text-sm font-semibold">Du sparst 100€ (67%)</div>
              </div>

              <a
                href="/"
                className="inline-block bg-gradient-to-r from-emerald-500 to-teal-500 text-white px-10 py-4 rounded-xl font-bold text-lg hover:from-yellow-400 hover:to-yellow-500 hover:text-black transition-all duration-300 shadow-2xl hover:shadow-yellow-400/50 hover:scale-105 transform mb-4"
                onClick={() => pushToDataLayer('click_to_offer_from_bodyboost')}
              >
                Ja, ich will den Einführungspreis sichern!
              </a>

              <div className="flex items-center justify-center gap-6 text-white/60 text-xs">
                <div className="flex items-center gap-1">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span>Geld-zurück-Garantie</span>
                </div>
                <div className="flex items-center gap-1">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                  </svg>
                  <span>Sichere Zahlung</span>
                </div>
                <div className="flex items-center gap-1">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
                  </svg>
                  <span>Sofortiger Zugang</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <Footer />
    </div>
  );
}
